import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'
import type { FC, PropsWithChildren } from 'react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import FooterBasic from '@segment/templates/FooterBasic'
import GettingStarted from '@segment/templates/GettingStarted'
import NavigationBrand from '@segment/templates/NavigationBrand'

import Layout from '@segment/next-shared/layout'

import RecommendedReading from './components/RecommendedReading'
import Methodology from './components/Methodology'
import Hero from './components/Hero'
import Introduction from './components/Introduction'
import KeyFindings from './components/KeyFindings'

import ogImageJpeg from './assets/OgGrowthReport.jpg'

const TheGrowthReportView: FC<PropsWithChildren> = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <Background>
        <Layout
          pageTitle="The Growth Report by Twilio Segment"
          pageDescription="How customer data fuels high-performance growth organizations"
          pageOG={ogImageJpeg}
          themeColor={theme.palette.brand.darkAcai[700]}
        >
          <NavigationBrand />
          <Main>
            <Hero />
            <Introduction />
            <KeyFindings />
            <Methodology />
            <RecommendedReading />
            <GettingStarted />
          </Main>
        </Layout>
        <FooterBasic />
      </Background>
    </AppearanceProvider>
  )
}

const Main = styled.main``

const Background = styled.div`
  /* use display grid to remove any white-spaces shifting a layout */
  display: grid;
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default TheGrowthReportView
